import { StrictMode } from "react";
import { createRoot } from "react-dom/client";
import { Toaster } from "react-hot-toast";
import "./index.css";
import App from "./App.tsx";

createRoot(document.getElementById("root")!).render(
  <StrictMode>
    <App />
    <Toaster
      toastOptions={{
        className:
          "font-fs! font-normal! text-main-mobile! text-white-main! duration-500! rounded-xl! bg-white-transparent!",
        duration: 10000,
        position: "bottom-center",
      }}
    />
  </StrictMode>
);
